import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import LandingPage from './pages/LandingPage';
import AboutPage from './pages/AboutPage';
import TeamPage from './pages/TeamPage';
import ThesisPage from './pages/ThesisPage';
import AuguryPage from './pages/AuguryPage';
import AuguryPostPage from './pages/AuguryPostPage';
import CareersPage from './pages/CareersPage';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/thesis" element={<ThesisPage />} />
          <Route path="/augury" element={<AuguryPage />} />
          <Route path="/augury/:id" element={<AuguryPostPage />} />
          <Route path="/careers" element={<CareersPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
